"use client"

import { createContext, useContext, useState, useEffect } from "react"
import { getCurrentCampus, setCurrentCampus } from "@/lib/supabase"

const CampusContext = createContext(null)

export function CampusProvider({ children }) {
  const [selectedCampus, setSelectedCampus] = useState(() => getCurrentCampus())

  const changeCampus = (campusId) => {
    setCurrentCampus(campusId)
    setSelectedCampus(campusId)
  }

  useEffect(() => {
    // Sincronizar con localStorage
    const handleStorageChange = (e) => {
      if (e.key === 'selected_campus') {
        setSelectedCampus(e.newValue || 'guadalajara')
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  return (
    <CampusContext.Provider value={{ selectedCampus, changeCampus }}>
      {children}
    </CampusContext.Provider>
  )
}

export function useCampus() {
  const context = useContext(CampusContext)
  if (!context) {
    throw new Error('useCampus debe usarse dentro de CampusProvider')
  }
  return context
}
